import React from "react";

function HighestTeamScores({ matches, loading }) {
    return (
        <div className="stfull">
            {loading ? (
                <div className="sfull-empty">Loading...</div>
            ) : matches.length === 0 ? (
                <div className="sfull-empty">No data available</div>
            ) : (
                <table>
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Team</th>
                        <th>Score</th>
                        <th>Against</th>
                        <th>Overs</th>
                    </tr>
                    </thead>
                    <tbody>
                    {matches.map((match, index) => (
                        <tr key={match.matchId} className={index === 0 ? "ldr" : ""}>
                            <td className={`hs-rank ${index === 0 ? "hs-rank-top" : ""}`}>{index + 1}</td>
                            <td>
                                <div className="hs-team-cell">
                                    <img src={match.team1Runs !== null ? match.team1PicURL : match.team2PicURL}
                                         alt={match.team1Runs !== null ? match.team1Name : match.team2Name}
                                         className="hs-img"
                                         onError={(e) => e.target.style.display = "none"}
                                    />
                                    {match.team1Runs !== null ? match.team1Name : match.team2Name}
                                </div>
                            </td>
                            <td className="hs-score">
                                {match.team1Runs !== null ? match.team1Runs : match.team2Runs}/{match.team1Runs !== null ? match.team1Wickets : match.team2Wickets}
                            </td>
                            <td>
                                <div className="hs-against">
                                    <img src={match.team1Runs !== null ? match.team2PicURL : match.team1PicURL}
                                         alt={match.team1Runs !== null ? match.team2Name : match.team1Name}
                                         className="hs-img"
                                         onError={(e) => e.target.style.display = "none"}
                                    />
                                    {match.team1Runs !== null ? match.team2Name : match.team1Name}
                                </div>
                            </td>
                            <td className="nrr-p">{match.team1Runs !== null ? match.team1Overs : match.team2Overs} OV</td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
}

export default HighestTeamScores;